// Logo de PresenzIA. Usa el icono histórico SVG (reloj + nodos neuronales + "IA")
// que vive en frontend/public/logo-presenzia-icon.svg, junto al wordmark.
export default function Logo({ size = 28, mark = true, label = true }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      {mark && (
        <img
          src="/logo-presenzia-icon.svg"
          alt=""
          width={size}
          height={size}
          className="block"
          style={{ width: size, height: size }}
          aria-hidden="true"
        />
      )}
      {label && (
        <span className="font-semibold tracking-tight" style={{ fontSize: size * 0.62 }}>
          Presenz<span className="ia-grad font-bold">IA</span>
        </span>
      )}
    </span>
  )
}
